import React, { ReactNode } from 'react'

interface ButtonProps {
    className?: string
    text?: string
    onClick?: () => void
    children?: ReactNode
}

export const Button: React.FC<ButtonProps> = ({ className, text, onClick, children }) => {
    return (
        <button className={`${className}`} onClick={onClick}>
            {text}
            {children}
        </button>
    )
}
